import {
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Tooltip,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Input, InputDate, InputImg, Select } from "../../controls";
import { DropLi, Model, UseForm } from "../../hooks";
import { Alert, Form, Tabs } from "../../layout";
import { ShuffleRounded } from "@mui/icons-material";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { RmvEmptyProp, ToFormData } from "../../hooks/Method";
import { useTranslation } from "react-i18next";

const AddEditMember = (props) => {
  const { convertInq = false } = props;
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { Gender } = DropLi();
  const { MemberMdl } = Model();
  const { branch, authUser } = useContext(AppContext);

  const {
    values,
    errors,
    setErrors,
    handleInpChg,
    handleInpDate,
    setValues,
    handleFile,
  } = UseForm(MemberMdl);
  const [inqDtls, setInqDtls] = useState();
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [statusLi, setStatusLi] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    if (id) {
      if (convertInq) {
        API(endpoints.Inquiry + actions.GetById).getById(id, (res) => {
          if (res && res.status === 200 && res.result) {
            setInqDtls(res.result);
            setValues((x) => ({ ...x, ...RmvEmptyProp(res.result), id: 0 }));
          }
        });
      } else
        API(endpoints.Member + actions.GetById).getById(id, (res) => {
          if (res && res.status === 200) {
            var val = res.result;
            setValues((x) => ({ ...x, ...val }));
          }
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (branch && branch.id) {
      API(endpoints.City + actions.GetAllByOrg).getById(
        branch.orgId,
        (res) =>
          res &&
          res.status === 200 &&
          setCities([...res.result.map((j) => ({ ...j, label: j.name }))])
      );
      API(endpoints.MemberStatus + actions.GetAllByOrg).getById(
        branch.orgId,
        (res) =>
          res &&
          res.status === 200 &&
          setStatusLi([...res.result.map((j) => ({ ...j, label: j.name }))])
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const validateForm = () => {
    let temp = {};
    temp.firstName = values.firstName !== "" ? "" : t("ValFirstName");
    temp.lastName = values.lastName !== "" ? "" : t("ValLastName");
    temp.gender = values.gender !== "" ? "" : t("ValGender");
    temp.mobile = values.mobile !== "" ? "" : t("ValMobile");
    temp.email = values.email !== "" ? "" : t("ValEmail");
    temp.memberId = values.memberId !== "" ? "" : t("ValMemberId");
    temp.cityId = values.cityId !== "" ? "" : t("ValCity");
    temp.dob = values.dob !== "" ? "" : t("ValDob");
    temp.enrollmentId = values.enrollmentId !== "" ? "" : t("ValEnrollmentId");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm() && branch.id && authUser.id) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res) {
          if (res.status === 201 || res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("Success"),
              subTitle: `${t("Member")} ${id ? t("Update") : t("Added")} ${t(
                "Successfully"
              )}.`,
              onClick: () => navigate("/members"),
            });
          } else
            setAlert({
              isOpen: true,
              type: "error",
              title: t("Error"),
              subTitle: res.msg,
            });
        }
      };
      if (values.id === 0) {
        values.branchId = branch.id;
        values.orgId = branch.orgId;
        values.addedUserId = authUser.id;
        API(endpoints.Member + actions.Post).post(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );

        // Convert Inquiry To Member, Change the inquiry status.
        if (convertInq && inqDtls) {
          API(endpoints.Inquiry + actions.MarkeMakeMember).getById(inqDtls.id);
        }
      } else {
        API(endpoints.Member + actions.Put).put(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
      }
    }
  };

  const handleGenerateCode = (name) => {
    setValues({
      ...values,
      [name]: Math.floor(1000000 + Math.random() * 1000000),
    });
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="mb-10 d-flex j-between a-center pt-15 pl-15 pr-15">
            <div>
              <h1
                className="form-title mb-5 fw-4 gray-color tx-upp
                    border-left"
              >
                {id ? t("Edit") : t("Add")} {t("Member")}
              </h1>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                {id ? t("SaveChanges") : t("Submit")}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="pl-15 pr-15 pb-15">
            <Tabs
              className="mt-30"
              header={[
                { label: t("GeneralFields"), icon: "" },
                { label: t("AdditionalFields"), icon: "" },
              ]}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Input
                    label={t("MemberId")}
                    name="memberId"
                    required={true}
                    value={values.memberId}
                    error={errors.memberId}
                    onChange={handleInpChg}
                    inputProps={{ maxLength: 200 }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip arrow title={t("GenerateMemberId")}>
                            <IconButton
                              onClick={() => handleGenerateCode("memberId")}
                            >
                              <ShuffleRounded />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Input
                    label={t("EnrollmentId")}
                    name="enrollmentId"
                    required={true}
                    value={values.enrollmentId}
                    error={errors.enrollmentId}
                    inputProps={{ maxLength: 200 }}
                    onChange={handleInpChg}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip arrow title="Generate Enrollment Id">
                            <IconButton
                              onClick={() => handleGenerateCode("enrollmentId")}
                            >
                              <ShuffleRounded />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Input
                    label={t("Mobile")}
                    name="mobile"
                    required={true}
                    inputProps={{ maxLength: 50 }}
                    value={values.mobile}
                    error={errors.mobile}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Input
                    label={t("FirstName")}
                    name="firstName"
                    inputProps={{ maxLength: 200 }}
                    required={true}
                    value={values.firstName}
                    error={errors.firstName}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Input
                    label={t("LastName")}
                    name="lastName"
                    inputProps={{ maxLength: 200 }}
                    required={true}
                    value={values.lastName}
                    error={errors.lastName}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputDate
                    label={t("DateOfBirth")}
                    name="dob"
                    inputProps={{ maxLength: 50 }}
                    required={true}
                    value={values.dob}
                    error={errors.dob}
                    onChange={(date) =>
                      handleInpDate("dob", new Date(date).toLocaleDateString())
                    }
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Input
                    label={t("Email")}
                    name="email"
                    inputProps={{ maxLength: 250 }}
                    required={true}
                    value={values.email}
                    error={errors.email}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Select
                    label={t("Gender")}
                    name="gender"
                    required={true}
                    value={values.gender}
                    error={errors.gender}
                    onChange={handleInpChg}
                    options={Gender}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Select
                    label={t("City")}
                    name="cityId"
                    required={true}
                    value={values.cityId}
                    error={errors.cityId}
                    onChange={handleInpChg}
                    options={cities}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <Input
                        label="RFID"
                        name="rfid"
                        inputProps={{ maxLength: 200 }}
                        value={values.rfid}
                        error={errors.rfid}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Input
                        label={t("Nationality")}
                        inputProps={{ maxLength: 150 }}
                        name="nationality"
                        value={values.nationality}
                        error={errors.nationality}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Input
                        label={t("CivilId")}
                        inputProps={{ maxLength: 150 }}
                        name="civilId"
                        value={values.civilId}
                        error={errors.civilId}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Select
                        label={t("MemberStatus")}
                        name="memberStatusId"
                        value={values.memberStatusId}
                        error={errors.memberStatusId}
                        onChange={handleInpChg}
                        options={statusLi}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Input
                        label={t("AlternateMobile")}
                        inputProps={{ maxLength: 50 }}
                        name="altMobile"
                        value={values.altMobile}
                        error={errors.altMobile}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Input
                        label={t("PrimaryAddress")}
                        inputProps={{ maxLength: 300 }}
                        name="address1"
                        value={values.address1}
                        error={errors.address1}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Input
                        label={t("SecondaryAddress")}
                        inputProps={{ maxLength: 300 }}
                        name="address2"
                        value={values.address2}
                        error={errors.address2}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Input
                        label={t("Remark")}
                        name="remark"
                        inputProps={{ maxLength: 500 }}
                        multiline
                        rows={3}
                        value={values.remark}
                        error={errors.remark}
                        onChange={handleInpChg}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={3}>
                  <InputImg
                    label={t("ProfilePhoto")}
                    name="photoFile"
                    src={values.photo}
                    rmv={() => {
                      setValues({ ...values, photoFile: "", photo: "" });
                    }}
                    onChange={handleFile}
                    error={errors.photoFile}
                  />
                </Grid>
              </Grid>
            </Tabs>
          </div>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddEditMember;
